import type { ReactNode } from 'react'
import styles from './Pane.module.css'

export interface PaneHeaderProps {
  title: string
  count?: number | string
  /**
   * Sits beside the title, before the actions.
   */
  meta?: ReactNode
  children?: ReactNode
}

export function PaneHeader({ title, count, meta, children }: PaneHeaderProps) {
  return (
    <div className={styles.header}>
      <h2 className={styles.title}>{title}</h2>
      {count !== undefined && <span className={styles.count}>{count}</span>}
      {meta}
      <span className={styles.spacer} />
      {children}
    </div>
  )
}

export interface PaneToolsProps {
  children: ReactNode
}

export function PaneTools({ children }: PaneToolsProps) {
  return <div className={styles.tools}>{children}</div>
}

export interface PaneBodyProps {
  children: ReactNode
}

export function PaneBody({ children }: PaneBodyProps) {
  return (
    <div className={styles.body}>
      <div>{children}</div>
    </div>
  )
}
